module.exports = __webpack_public_path__ + "static/img/7.b2a98a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/7.png
// module id = uAcj
// module chunks = 0